<template>
  <div class="statistics-container" id="scrollTo">
    <!-- 页面标题和类型切换 -->
    <div class="page-header">
      <!-- <h1 class="page-title">数据统计</h1> -->
      <div class="type-switcher">
        <el-button
          v-if="type == 1 || type == 2"
          :type="gettype"
          v-loading.fullscreen.lock="fullscreenLoading"
          class="type-btn"
          @click="changetype(1)"
        >
          <i class="el-icon-data-analysis"></i>
          (771,772)/775/776/779/780/781/782/783
        </el-button>
        <el-button
          v-if="type == 1 || type == 3"
          :type="gettypeseven"
          v-loading.fullscreen.lock="fullscreenLoading"
          class="type-btn"
          @click="changetype(2)"
        >
          <i class="el-icon-refrigerator"></i>
          来印冰箱贴
        </el-button>
      </div>
    </div>
    <keep-alive include="">
      <sevencard v-show="gettypeseven == 'success'" :type="type"></sevencard>
    </keep-alive>
    <!-- 筛选项  -->
    <keep-alive include="">
      <div v-show="gettype == 'success'" class="filter-section">
        <el-card class="filter-card" id="0" shadow="hover">
          <div slot="header" class="card-header">
            <span class="card-title">
              <i class="el-icon-search"></i>
              筛选条件
            </span>
            <div v-if="regionLists.length > 0" class="topBtn" ref="scrollBox">
              <button v-for="item in regionLists" :key="item.region" @click="areaBtn(item.region)" :class="{ activeBtn: region == item.region }">
                {{ item.region_name }}
              </button>
              <!-- <button @click="areaBtn(1)" :class="{ activeBtn: region == 1 }">
                中国大陆
              </button>
              <button @click="areaBtn(2)" :class="{ activeBtn: region == 2 }">
                中国香港
              </button>
              <button @click="areaBtn(3)" :class="{ activeBtn: region == 3 }">
                中国澳门
              </button>
              <button @click="areaBtn(4)" :class="{ activeBtn: region == 4 }">
                中国台湾
              </button>
              <button @click="areaBtn(5)" :class="{ activeBtn: region == 5 }">
                阿联酋
              </button>
              <button @click="areaBtn(6)" :class="{ activeBtn: region == 6 }">
                美国
              </button>
              <button @click="areaBtn(7)" :class="{ activeBtn: region == 7 }">
                韩国
              </button> -->
            </div>
          </div>
          
          <el-form
            ref="form"
            :inline="true"
            label-position="right"
            label-width="80px"
            :model="reqForm"
            @submit.native.prevent
            class="filter-form filter-form--compact"
          >
            <div class="form-grid form-grid--compact">
              <el-form-item label="景区名称" class="form-item">
                <SearchSelect
                  v-model="company_id_list"
                  :options="storeList"
                  :props="{
                    label: 'name',
                    value: 'id',
                  }"
                  placeholder="请选择景区"
                />
              </el-form-item>
              <el-form-item label="ERP仓库" class="form-item">
                <SearchSelect
                  className="longSelect"
                  v-model="erpstore"
                  :options="allErpStore"
                  :props="{
                    label: 'store_name',
                    value: 'store_id',
                  }"
                  placeholder="请选择ERP仓库"
                />
              </el-form-item>
              <el-form-item label="设备名称" class="form-item">
                <SearchSelect
                  v-model="device_id_list"
                  :options="filterDevices"
                  :props="{
                    label: 'name',
                    value: 'id',
                  }"
                  placeholder="请选择设备"
                />
              </el-form-item>
              <el-form-item label="时间" class="form-item">
                <el-date-picker
                  v-model="timeRange"
                  end-placeholder="结束日期"
                  range-separator="至"
                  start-placeholder="开始日期"
                  :picker-options="pickerOptions"
                  type="daterange"
                />
              </el-form-item>
            </div>
            <div class="form-actions form-actions--compact">
              <el-button type="primary" @click="fetchData">
                <i class="el-icon-search"></i>
                查询
              </el-button>
              <el-button type="success" @click="product">
                <i class="el-icon-download"></i>
                商品总览表
              </el-button>
              <el-button type="success" @click="productdevice">
                <i class="el-icon-download"></i>
                设备商品总览表
              </el-button>
              <el-button type="success" @click="productdevicedetail">
                <i class="el-icon-download"></i>
                设备商品明细表
              </el-button>
            </div>
          </el-form>
          <!-- <el-radio-group v-model="source" style="margin-bottom: 20px;">
            <el-radio :label="0" border>全部</el-radio>
            <el-radio :label="1" border>纪念章</el-radio>
            <el-radio :label="2" border>大牌</el-radio>
            <el-radio :label="3" border>776</el-radio>
            <el-radio :label="4" border>779</el-radio>
            <el-radio :label="5" border>780</el-radio>
            <el-radio :label="6" border>781</el-radio>
            <el-radio :label="7" border>782</el-radio>
            <el-radio :label="8" border>783</el-radio>
          </el-radio-group> -->
          <el-collapse
            v-model="activeNames"
            @change="handleChange"
            class="dashboard-collapse"
          >
            <el-collapse-item title="仪表盘" name="2" class="dashboard-item">
              <div slot="title" class="collapse-title">
                <i class="el-icon-data-analysis"></i>
                仪表盘
              </div>
              <chaertstable :list="list"></chaertstable>
            </el-collapse-item>
          </el-collapse>
        </el-card>

        <!-- 数据展示区域 -->
        <div v-if="dataList" class="data-section">
          <!-- 综合数据 -->
          <div v-if="countDataList" class="data-card" id="5">
            <el-card class="content-card" shadow="hover">
              <div slot="header" class="card-header">
                <span class="card-title">
                  <i class="el-icon-data-line"></i>
                  综合数据
                </span>
              </div>
              <tablecard :countdata="countDataList" :filterPos="true"></tablecard>
            </el-card>
          </div>
          <!-- 数据项循环渲染 -->
          <div
            v-for="(dataItem, key) in dataList"
            :key="key"
            class="data-card"
            :id="getTableId(key)"
          >
            <el-card class="content-card" shadow="hover">
              <div slot="header" class="card-header">
                <span class="card-title">
                  <i class="el-icon-s-data"></i>
                  {{ getTableTitle(key) }}
                </span>
              </div>
              <tablecard
                :countdata="dataItem.total"
                :data="getTableData(key, dataItem.detail)"
                :filterPos="[2, 5, '2', '5'].includes(key) ? false : true"
              ></tablecard>
            </el-card>
          </div>
        </div>
        <!-- 实现电梯导航 -->
        <div
          class="elevator-nav"
          @mouseenter="changetable"
          @mouseleave="seetable"
          id="elevator"
        >
          <div class="nav-title">
            <i class="el-icon-menu"></i>
            快速导航
          </div>
          <div v-for="item in dynamicNavList" :key="item.id" class="nav-item">
            <el-button
              @click="changenav(item.id)"
              class="nav-btn"
              :class="{ 'nav-btn-top': item.id === 0 }"
            >
              <i v-if="item.id === 0" class="el-icon-top"></i>
              <i v-else class="el-icon-data-line"></i>
              {{ item.value }}
            </el-button>
          </div>
        </div>
      </div>
    </keep-alive>
  </div>
</template>

<script>
import {
  getStoreList,
  getDeviceList,
  getdata,
  productdown,
  productdevicedown,
  productdevicedetaildown,
  getRegionList
} from '@/api/datastatistics'
import tablecard from './nav'
import sevencard from './seven'
import chaertstable from './charts.vue'
import SearchSelect from '@/views/components/SearchSelect'
import { getErpStoreList } from '@/api/bi'
export default {
  name: 'Statistics',
  components: {
    tablecard,
    sevencard,
    chaertstable,
    SearchSelect,
  },
  props: ['allStore', 'allDevice'], // 全部景区列表、设备列表
  data() {
    return {
      region: 0,
      list: {},
      source: 0,
      chartlist: null,
      tableType: null,
      type: null,
      gettype: '',
      gettypeseven: '',
      filteredOptions: [], // 筛选的设备列表
      filteredstoreOptions: [], // 筛选的景区列表
      fullscreenLoading: false,
      typeof: true,
      activeNames: ['2'],
      storeList: [], // 景区列表
      deviceList: [], // 设备列表
      tabledata: [], //  表格数据
      dataList: [], // 总数据
      payMapList: [], // 总支付数据
      countDataList: [], // 总类型数据
      timeRange: [],
      company_id_list: [],
      device_id_list: [],
      erpstore: [],
      allErpStore: [],
      reqForm: {
        company_id_list: [],
        source: [],
        device_id_list: [],
      },
      filterDevices: this.deviceList instanceof Array ? this.deviceList : [], // 经过景区筛选后的设备列表(默认是全部的设备)
      activeName: this.$store.getters.permissions, // 默认展示的是哪一个权限
      navlist: [],
      pickerOptions: {
        disabledDate(time) {
          // time.getTime() > 今天零点时间戳 → 禁用
          const todayZero = new Date(new Date().toLocaleDateString()).getTime();
          return time.getTime() >= todayZero;
        }
      },
      regionLists: [],
    }
  },
  computed: {
    // 动态生成导航列表
    dynamicNavList() {
      const navItems = []

      // 如果有综合数据，添加综合数据导航
      if (this.countDataList && this.countDataList.length > 0) {
        navItems.push({
          id: 5,
          value: '综合数据',
        })
      }

      // 根据实际数据添加对应的导航项
      if (this.dataList) {
        Object.keys(this.dataList).forEach((key) => {
          const dataItem = this.dataList[key]
          if (dataItem && dataItem.total) {
            const navItem = this.getNavItemByKey(key)
            if (navItem) {
              navItems.push(navItem)
            }
          }
        })
      }

      // 添加回到顶部
      navItems.push({
        id: 0,
        value: '回到顶部',
      })

      return navItems
    },
  },
  created() {
    if (
      this.activeName.includes('portal:statistics_CommemorativeMedal') &&
      this.activeName.includes('portal:statistics _refrigeratorstickers')
    ) {
      this.type = '1' // 同时拥有纪念章大牌和777数据
      this.gettype = 'success'
    } else if (
      this.activeName.includes('portal:statistics_CommemorativeMedal') &&
      !this.activeName.includes('portal:statistics _refrigeratorstickers')
    ) {
      this.type = '2' // 有纪念章大牌数据
      this.gettype = 'success'
    } else if (
      !this.activeName.includes('portal:statistics_CommemorativeMedal') &&
      this.activeName.includes('portal:statistics _refrigeratorstickers')
    ) {
      this.type = '3' // 有777数据
      this.gettypeseven = 'success'
    }
    if (this.type == 2 || this.type == 1) {
      this.getAllStore()
      this.setDefaultDate()
    }
    getErpStoreList().then((res) => {
      this.allErpStore = res.data
    })
  },
  mounted() {
    this.getRegionLists()
    
  },
  watch: {
    company_id_list(newVal, oldVal) {
      // 检测景区变化，就更新设备
      // 根据景区搜索设备
      if (newVal.length === 0) {
        this.filterDevices =
          this.deviceList instanceof Array ? this.deviceList : [] // 防止没有数据的时候，是{} 不是[]
      } else {
        const params = { company_id_list: newVal }
        getDeviceList(params).then((res) => {
          this.filterDevices = res.data instanceof Array ? res.data : []
        })
      }
    },
  },
  methods: {
    getRegionLists() {
      getRegionList().then((res) => {
        this.regionLists = res.body
        if(this.regionLists.length){
          this.region = this.regionLists[0].region
          if (this.type == 2 || this.type == 1) {
            this.fetchData()
          }
        } else {
          this.region = 0
          if (this.type == 2 || this.type == 1) {
            this.fetchData()
          }
        }
        // 初始化拖动 ✅
        this.$nextTick(() => {
            this.initHorizontalDrag()
        })
      })
    },
    // 根据数据key获取对应的导航项
    getNavItemByKey(key) {
      const navMap = {
        1: { id: 2, value: '纪念章数据' },
        2: { id: 3, value: '大牌数据' },
        3: { id: 8, value: '776数据' },
        4: { id: 9, value: '779数据' },
        5: { id: 10, value: '780数据' },
        6: { id: 11, value: '781数据' },
        7: { id: 12, value: '782数据' },
        8: { id: 13, value: '783数据' },
      }
      return navMap[key] || null
    },
    // 获取表格ID
    getTableId(key) {
      switch (String(key)) {
        case '1':
          return '2'
        case '2':
          return '3'
        case '3':
          return '8'
        case '4':
          return '9'
        case '5':
          return '10'
        case '6':
          return '11'
        case '7':
          return '12'
        case '8':
          return '13'
        default:
          return ''
      }
    },
    // 获取表格标题
    getTableTitle(key) {
      switch (String(key)) {
        case '1':
          return '纪念章数据'
        case '2':
          return '大牌数据'
        case '3':
          return '776数据'
        case '4':
          return '779数据'
        case '5':
          return '780数据'
        case '6':
          return '781数据'
        case '7':
          return '782数据'
        case '8':
          return '783数据'
        default:
          return ''
      }
    },
    // 获取表格数据
    getTableData(key, detail) {
      return key === '1' ? detail.slice(0, 100) : detail
    },
    // 切换数据类型
    changetype(val) {
      if (val == 1) {
        this.gettype = 'success'
        this.gettypeseven = ''
      } else if (val == 2) {
        this.gettype = ''
        this.gettypeseven = 'success'
      }
    },
    // 下载商品总览表
    product() {
      var queryForm = this.getReq()
      productdown({
        start: queryForm.start,
        end: queryForm.end,
        company_id_list: this.company_id_list,
        device_id_list: this.device_id_list,
        source: queryForm.source,
        store_id_list: this.erpstore,
      })
        .then((data) => {
          this.download(data)
        })
        .catch((error) => {
          this.$message.error(error)
          console.log('报错信息', error)
        })
    },
    productdevice() {
      var queryForm = this.getReq()
      productdevicedown({
        start: queryForm.start,
        end: queryForm.end,
        company_id_list: this.company_id_list,
        device_id_list: this.device_id_list,
        source: queryForm.source,
        store_id_list: this.erpstore,
      })
        .then((data) => {
          this.download(data)
        })
        .catch((error) => {
          this.$message.error(error)
          console.log('报错信息', error)
        })
    },
    productdevicedetail() {
      var queryForm = this.getReq()
      if (this.company_id_list.length == 0) {
        this.$message.error('明细表景区必填')
        return
      }
      productdevicedetaildown({
        start: queryForm.start,
        end: queryForm.end,
        company_id_list: this.company_id_list,
        device_id_list: this.device_id_list,
        source: queryForm.source,
        store_id_list: this.erpstore,
      })
        .then((data) => {
          this.download(data)
        })
        .catch((error) => {
          this.$message.error(error)
          console.log('报错信息', error)
        })
    },
    download(resp) {
      const fileName = '数据'
      const blob = new Blob([resp.data], { type: 'application/vnd.ms-excel' })
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, fileName)
      } else {
        const href = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.style.display = 'none'
        a.href = href
        a.download = fileName
        a.click()
        URL.revokeObjectURL(a.href)
      }
    },
    //   下载报表
    getDownload() {},
    downExcel1() {},
    handleChange(val) {},
    changetable() {
      const elevator = document.getElementById('elevator')
      elevator.style.opacity = '1' // 设置透明度为 1
    },
    seetable() {
      const elevator = document.getElementById('elevator')
      elevator.style.opacity = '0.2' // 设置透明度为 0.2
    },
    // 电梯导航
    changenav(val) {
      if (!this.dataList['2'] && val == 3) {
        this.$message.error('无数据')
        return
      } else if (!this.dataList['3'] && val == 8) {
        this.$message.error('无数据')
        return
      } else if (!this.dataList['4'] && val == 9) {
        this.$message.error('无数据')
        return
      } else if (!this.dataList['5'] && val == 10) {
        this.$message.error('无数据')
        return
      } else if (!this.dataList['6'] && val == 11) {
        this.$message.error('无数据')
        return
      } else if (!this.dataList['7'] && val == 12) {
        this.$message.error('无数据')
        return
      } else if (!this.dataList['8'] && val == 13) {
        this.$message.error('无数据')
        return
      } else {
        let scr = document.getElementById(val)
        if (scr) {
          scr.scrollIntoView({ behavior: 'smooth' })
        }
      }
    },
    // 查询数据
    async fetchData() {
      var queryForm = this.getReq()

      try {
        const res = await getdata({
          start: queryForm.start,
          end: queryForm.end,
          company_id_list: this.company_id_list,
          device_id_list: this.device_id_list,
          store_id_list: this.erpstore,
          region: this.region,
        })

        if (res.code === 2000) {
          this.list = res.data
          this.dataList = res.data
          this.dataList = res.data.deviceMap
          this.payMapList = res.data.payMapList
          this.countDataList = res.data.totalMapList
          // let bar = this.optionPie;
          // bar.series[0].data = res.data.payMapList;
          // this.renderPieChart(bar);
        } else {
          this.tabledata = []
        }
      } catch (e) {
        this.$message.error(e.msg)
        console.log(e)
      }
    },
    formatDate(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    getReq() {
      var queryForm = { ...this.reqForm }
      if (this.timeRange != null) {
        const [startDate, endDate] = this.timeRange
        queryForm.start = this.formatDate(startDate) // 不需要调用 startDate.getTime()
        queryForm.end = this.formatDate(endDate) // 不需要调用 endDate.getTime()
      } else {
        queryForm.start = ''
        queryForm.end = ''
      }
      return queryForm
    },

    // 传递时间组件
    setDefaultDate() {
      const today = new Date() // 获取当前时间
      today.setHours(0, 0, 0, 0) // 设置时、分、秒、毫秒为 0，即将时间设置为当天的 00:00:00.000

      const yesterdayStart = new Date(today) // 创建一个昨天的副本
      yesterdayStart.setDate(today.getDate() - 1) // 将日期设置为昨天
      yesterdayStart.setHours(0, 0, 0, 0) // 设置时、分、秒、毫秒为 0，即将时间设置为昨天的 00:00:00.000

      const yesterdayEnd = new Date(today) // 创建一个昨天的副本
      yesterdayEnd.setDate(today.getDate() - 1) // 将日期设置为昨天
      yesterdayEnd.setHours(23, 59, 59, 999) // 设置时、分、秒、毫秒为最大值，即将时间设置为昨天的 23:59:59.999

      this.timeRange = [yesterdayStart, yesterdayEnd] // 设置时间范围为昨天的起始时间到结束时间
    },
    getAllStore() {
      getStoreList().then((res) => {
        if (res.code === 2000) {
          this.storeList = res.data
        }
      })
      getDeviceList().then((res) => {
        if (res.code === 2000) {
          this.deviceList = res.data
          this.filterDevices = this.deviceList
        }
      })
    },
    areaBtn(num) {
      this.region = num
      // switch (num) {
      //   case 1:
      //     this.unit = '元'
      //     this.unitSymbol = '￥'
      //     break
      //   case 2:
      //     this.unit = '港元'
      //     this.unitSymbol = 'HK$'
      //     break
      //   case 3:
      //     this.unit = '澳元'
      //     this.unitSymbol = 'MOP$'
      //     break
      //   case 4:
      //     this.unit = '台币'
      //     this.unitSymbol = 'NT$'
      //     break
      //   case 5:
      //     this.unit = '迪拉姆'
      //     this.unitSymbol = 'د.إ'
      //     break
      //   case 6:
      //     this.unit = '美元'
      //     this.unitSymbol = '$'
      //     break
      //   case 7:
      //     this.unit = '韩元'
      //     this.unitSymbol = '₩‌'
      //     break
      // }
      this.fetchData()
    },
    // 横向拖动滚动
    initHorizontalDrag() {
        const el = this.$refs.scrollBox
        if (!el) return

        let isMouseDown = false
        let startX = 0
        let scrollLeft = 0

        // 鼠标按下
        el.addEventListener('mousedown', (e) => {
            isMouseDown = true
            el.style.cursor = 'grabbing'
            startX = e.pageX - el.offsetLeft
            scrollLeft = el.scrollLeft
        })

        // 鼠标离开/松开
        el.addEventListener('mouseup', () => {
            isMouseDown = false
            el.style.cursor = 'grab'
        })
        el.addEventListener('mouseleave', () => {
            isMouseDown = false
            el.style.cursor = 'grab'
        })

        // 鼠标移动
        el.addEventListener('mousemove', (e) => {
            if (!isMouseDown) return
            e.preventDefault()
            const x = e.pageX - el.offsetLeft
            const distance = (x - startX) * 1.5
            el.scrollLeft = scrollLeft - distance
        })
    },
  },
}
</script>

<style scoped lang="scss">
// 主容器样式
.statistics-container {
  min-height: 100vh;
  background: #f8f9fa;
  padding: 20px;
}

// 页面头部样式
.page-header {
  margin-bottom: 24px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid #e9ecef;
  padding: 20px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .page-title {
    font-size: 28px;
    font-weight: 600;
    color: #2c3e50;
    margin: 0;
  }

  .type-switcher {
    display: flex;
    gap: 12px;

    .type-btn {
      padding: 10px 20px;
      border-radius: 6px;
      font-weight: 500;
      transition: all 0.3s ease;
      border: 1px solid #e9ecef;
      display: flex;
      align-items: center;
      gap: 6px;

      &:hover {
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      }

      &.el-button--success {
        background: #28a745;
        border-color: #28a745;
        color: white;

        &:hover {
          background: #218838;
          border-color: #1e7e34;
        }
      }
    }
  }
}

// 筛选区域样式
.filter-section {
  margin-bottom: 24px;

  .filter-card {
    border-radius: 8px;
    border: 1px solid #e9ecef;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    & ::v-deep .el-card__header{
      border-bottom: none;
    }
    .card-header {
      background: #ffffff;
      color: #2c3e50;
      // padding: 15px 20px;
      margin: -20px -20px 0px -20px;
      border-radius: 12px 12px 0 0;
      border-bottom: 1px solid #e9ecef;
      box-sizing: border-box;
      .card-title {
        font-size: 16px;
        font-weight: 600;
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 20px;
        box-sizing: border-box;
        border: 1px solid #EBEEF5;
      }
    }
    .topBtn {
      display: flex;
      // margin-bottom: 20px;
      padding: 20px;
      box-sizing: border-box;
      // border-bottom: 1px solid #EBEEF5;
      /* 核心：纯CSS横向拖动滚动 */
      overflow-x: auto;
      overflow-y: hidden;
      white-space: nowrap;
      -webkit-overflow-scrolling: touch; /* 苹果流畅滚动 */
      scroll-behavior: smooth; /* 平滑滚动 */

      /* 隐藏滚动条 */
      scrollbar-width: none;
      -ms-overflow-style: none;

      /* 鼠标抓手 */
      cursor: grab;
      button{
        // width: 100px;
        // height: 40px;
        border-radius: 8px;
        color: #000;
        background: transparent;
        border: 1px solid #bcbcbc;
        margin-right: 10px;
        font-size: 18px;
        cursor: pointer;
        white-space: nowrap;
        padding: 8px 12px;
        user-select: none;
      }
      
      .activeBtn {
        background: #4d77d0;
        color: #FFF;
        border: none;
        font-weight: 600;
      }
    }
    /* 彻底隐藏滚动条（Chrome/Edge/Safari） */
    .topBtn::-webkit-scrollbar {
      display: none;
    }
    .filter-form {
      .form-grid {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 8px 12px;
        margin-bottom: 8px;

        &.form-grid--compact {
          gap: 6px 10px;
        }

        .form-item {
          margin: 0;
          ::v-deep .el-form-item__label {
            font-weight: 500;
            color: #2c3e50;
            font-size: 14px;
          }
        }
      }

      .form-actions {
        display: flex;
        gap: 6px;
        justify-content: flex-start;
        padding-top: 0;
        border-top: none;
        flex-wrap: wrap;
        align-items: center;

        .action-btn {
          padding: 6px 10px;
          border-radius: 4px;
          font-weight: 500;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          gap: 6px;
          font-size: 12px;

          &:hover {
            transform: translateY(-1px);
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
          }

          &.primary-btn {
            background: #007bff;
            border-color: #007bff;
            color: white;

            &:hover {
              background: #0056b3;
              border-color: #004085;
            }
          }

          &.action-btn--compact {
            padding: 4px 8px;
            font-size: 12px;
            border-radius: 4px;
          }
        }
      }
    }
  }
}

// 仪表盘折叠面板样式
.dashboard-collapse {
  margin-top: 20px;

  .dashboard-item {
    ::v-deep .el-collapse-item__header {
      background: #ffffff;
      color: #2c3e50;
      border-radius: 8px;
      padding: 15px 20px;
      font-weight: 600;
      border: 1px solid #e9ecef;

      .collapse-title {
        display: flex;
        align-items: center;
        gap: 8px;
      }
    }

    ::v-deep .el-collapse-item__content {
      padding: 20px;
      background: white;
      border-radius: 0 0 8px 8px;
    }
  }
}

// 数据展示区域样式
.data-section {
  .data-card {
    margin-bottom: 30px;

    .content-card {
      border-radius: 8px;
      border: 1px solid #e9ecef;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
      transition: all 0.3s ease;

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
      }

      .card-header {
        background: #ffffff;
        color: #2c3e50;
        padding: 15px 20px;
        margin: -20px -20px 20px -20px;
        border-radius: 12px 12px 0 0;
        border-bottom: 1px solid #e9ecef;

        .card-title {
          font-size: 18px;
          font-weight: 600;
          display: flex;
          align-items: center;
          gap: 8px;
        }
      }
    }
  }
}

// 电梯导航样式
.elevator-nav {
  position: fixed;
  z-index: 1000;
  right: 24px;
  top: 50%;
  transform: translateY(-50%);
  opacity: 0.3;
  transition: all 0.3s ease;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid #e9ecef;
  padding: 12px;
  min-width: 140px;

  &:hover {
    opacity: 1;
    transform: translateY(-50%) scale(1.05);
  }

  .nav-title {
    font-size: 14px;
    font-weight: 600;
    color: #2c3e50;
    text-align: center;
    margin-bottom: 12px;
    padding-bottom: 8px;
    border-bottom: 1px solid #e9ecef;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
  }

  .nav-item {
    margin-bottom: 6px;

    &:last-child {
      margin-bottom: 0;
    }

    .nav-btn {
      width: 100%;
      padding: 8px 12px;
      border-radius: 6px;
      font-size: 12px;
      font-weight: 500;
      transition: all 0.3s ease;
      border: 1px solid #e9ecef;
      background: white;
      color: #2c3e50;
      text-align: left;
      display: flex;
      align-items: center;
      gap: 6px;

      &:hover {
        background: #f8f9fa;
        color: #2c3e50;
        transform: translateX(-3px);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        border-color: #dee2e6;
      }

      &.nav-btn-top {
        background: #f8f9fa;
        color: #2c3e50;
        border-color: #dee2e6;

        &:hover {
          background: #e9ecef;
          transform: translateX(-3px) scale(1.02);
        }
      }
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  .statistics-container {
    padding: 10px;
  }

  .page-header {
    flex-direction: column;
    gap: 16px;
    text-align: center;

    .page-title {
      font-size: 24px;
    }

    .type-switcher {
      justify-content: center;
    }
  }

  .filter-form {
    .form-grid {
      grid-template-columns: 1fr;
      gap: 16px;
    }

    .form-actions {
      flex-direction: column;

      .action-btn {
        width: 100%;
        justify-content: center;
      }
    }
  }

  .elevator-nav {
    right: 10px;
    min-width: 120px;
    padding: 10px;

    .nav-btn {
      font-size: 11px;
      padding: 6px 10px;
    }
  }
}

// 图表容器样式
.Pie {
  display: flex;
  justify-content: center;
  width: 100%;
  max-width: 500px;
  height: 300px;
  margin: 20px auto;

  .chart {
    width: 100%;
    height: 100%;
  }
}

// 动画效果
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.data-card {
  animation: fadeInUp 0.6s ease-out;
}

// 滚动条样式
::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: #dee2e6;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #adb5bd;
}
</style>
